import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { ProfileProvider } from "context/ProfileContext";
import { WebSocketProvider } from "context/WebSocketContext"; // Import the WebSocketProvider
import { ToastContainer } from "react-toastify";
import { isPendingVendorSession, isTokenExpired } from "utils/session";

const buildSocketUrl = (baseUrl, path) => {
  if (!baseUrl) return "";

  const normalizedBase = baseUrl.replace(/\/+$/, "");
  const socketBaseUrl = normalizedBase.replace(/^https?/, (match) =>
    match === "https" ? "wss" : "ws"
  );
  const apiBaseUrl = socketBaseUrl.endsWith("/api") ? socketBaseUrl : `${socketBaseUrl}/api`;

  return `${apiBaseUrl}${path}`;
};

const App = () => {
  const [userId, setUserId] = useState(null);
  const [webSocketUrl, setWebSocketUrl] = useState("");

  const vendorToken = sessionStorage.getItem("VendorToken");
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}"); // Parse userData from localStorage
  // const userId = userData.user_id; // Extract user_id from userData
  // const webSocketUrl = `wss://aichatbot.spaincentral.cloudapp.azure.com/api/ws/agent/${userId}`;

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
    // Only open the socket for a usable session: a real user, not a pending
    // vendor, and a token that hasn't already expired. Opening with a dead
    // token just triggers a server auth-reject and a reconnect storm.
    if (userData.user_id && !isPendingVendorSession(userData) && !isTokenExpired(vendorToken)) {
      setUserId(userData.user_id);
      setWebSocketUrl(
        buildSocketUrl(
          process.env.REACT_APP_API_BASE_URL,
          `/ws/agent/${userData.user_id}?token=${encodeURIComponent(vendorToken || "")}`
        )
      );
    } else {
      setWebSocketUrl("");
    }
  }, [vendorToken]);

  return (
    <ProfileProvider>
      <WebSocketProvider url={webSocketUrl}>
        <ToastContainer />
        <Routes>
          {vendorToken ? (
            <>
              <Route path="admin/auth/*" element={<AuthLayout />} />
              <Route path="admin/*" element={<AdminLayout />} />
              <Route path="/" element={<Navigate to={`/admin/${userId}`} replace />} />
            </>
          ) : (
            <Route path="admin/auth/*" element={<AuthLayout />} />
          )}
          <Route
            path="/"
            element={
              vendorToken ? (
                <Navigate to={`/admin/${userId}`} replace />
              ) : (
                <Navigate to="/admin/auth/sign-in" replace />
              )
            }
          />
          <Route
            path="*"
            element={
              vendorToken ? (
                <Navigate to={`/admin/${userId}`} replace />
              ) : (
                <Navigate to="/admin/auth/sign-in" replace />
              )
            }
          />
        </Routes>
      </WebSocketProvider>
    </ProfileProvider>
  );
};

export default App;
